import React, { useState } from 'react';
import { X, Loader2, Send, CheckCircle2 } from 'lucide-react';
import { listingsApi } from '../api/client';
import { useAuth } from '../context/AuthContext';

const MessageModal = ({ open, onClose, listing }) => {
  const { user } = useAuth();
  const [form, setForm] = useState({ from_name: '', from_email: '', from_phone: '', body: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);

  React.useEffect(() => {
    if (open) {
      setSent(false); setError('');
      setForm({
        from_name: user?.name || '',
        from_email: user?.email || '',
        from_phone: '',
        body: '',
      });
    }
  }, [open, user]);

  if (!open || !listing) return null;

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await listingsApi.sendMessage(listing.id, {
        from_name: form.from_name,
        from_email: form.from_email || null,
        from_phone: form.from_phone || null,
        body: form.body,
      });
      setSent(true);
    } catch (err) {
      setError(err?.response?.data?.detail || 'Nachricht konnte nicht gesendet werden');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[90] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-[#1a1417] border border-[#2a1f24] rounded-2xl p-6 relative">
        <button onClick={onClose} className="absolute top-4 right-4 text-[#7a6b65] hover:text-white" aria-label="Schliessen">
          <X className="w-5 h-5" />
        </button>

        {sent ? (
          <div className="text-center py-6">
            <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-[#1c2a1f] border border-[#2f5a35] flex items-center justify-center">
              <CheckCircle2 className="w-7 h-7 text-[#9af0a8]" />
            </div>
            <h3 className="font-serif text-xl text-white mb-2">Nachricht gesendet</h3>
            <p className="text-sm text-[#9a8a83] mb-5">Deine Nachricht wurde an {listing.name} übermittelt.</p>
            <button onClick={onClose}
              className="px-5 py-2.5 rounded-md bg-[#a83a5b] hover:bg-[#bf456b] text-white font-medium">
              Schliessen
            </button>
          </div>
        ) : (
          <>
            <h2 className="font-serif text-2xl text-white mb-1">Nachricht senden</h2>
            <p className="text-sm text-[#9a8a83] mb-5">An: <span className="text-white">{listing.name}</span></p>
            <form onSubmit={submit} className="space-y-3">
              <input type="text" required placeholder="Dein Name *" value={form.from_name}
                onChange={(e) => setForm({ ...form, from_name: e.target.value })}
                className="w-full bg-[#241a1f] border border-[#2a1f24] rounded-md px-3 py-2.5 text-sm text-white placeholder:text-[#5a4d48] focus:outline-none focus:border-[#a83a5b]" />
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <input type="email" placeholder="E-Mail (optional)" value={form.from_email}
                  onChange={(e) => setForm({ ...form, from_email: e.target.value })}
                  className="w-full bg-[#241a1f] border border-[#2a1f24] rounded-md px-3 py-2.5 text-sm text-white placeholder:text-[#5a4d48] focus:outline-none focus:border-[#a83a5b]" />
                <input type="tel" placeholder="Telefon (optional)" value={form.from_phone}
                  onChange={(e) => setForm({ ...form, from_phone: e.target.value })}
                  className="w-full bg-[#241a1f] border border-[#2a1f24] rounded-md px-3 py-2.5 text-sm text-white placeholder:text-[#5a4d48] focus:outline-none focus:border-[#a83a5b]" />
              </div>
              <textarea required minLength={2} rows={5} placeholder="Deine Nachricht *" value={form.body}
                onChange={(e) => setForm({ ...form, body: e.target.value })}
                className="w-full bg-[#241a1f] border border-[#2a1f24] rounded-md px-3 py-2.5 text-sm text-white placeholder:text-[#5a4d48] focus:outline-none focus:border-[#a83a5b]" />
              {error && <p className="text-sm text-[#ff8aa3]">{error}</p>}
              <button type="submit" disabled={loading}
                className="w-full px-4 py-2.5 rounded-md bg-[#a83a5b] hover:bg-[#bf456b] disabled:opacity-60 text-white font-medium inline-flex items-center justify-center gap-2">
                {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
                {loading ? 'Wird gesendet...' : 'Nachricht senden'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default MessageModal;
